// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button.pagination__link{background:#fff!important}", "",{"version":3,"sources":["webpack://./resources/assets/js/my-account/components/Pagination.vue"],"names":[],"mappings":"AAAA,wBAAA,yBAAA","sourcesContent":["button.pagination__link{background:#fff !important}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
